import React, { useEffect } from "react";
import { useRoot } from "../context/RootContext";
import { useLocation } from "@remix-run/react";
import { Box, Text, Center, Icon } from "@chakra-ui/react";
import { MdSchool } from "react-icons/md";

export let loader = async () => {
  return { type: "home" };
};

export default function Home() {
  const {
    setTaskTypeName,
    setSubTopicName,
    setTopicName,
    setSubjectName,
    setTaskCatagory,
  } = useRoot();

  const location = useLocation();
  const { flag } = location?.state || { flag: false };

  useEffect(() => {
    setSubTopicName("");
    setTopicName("");
    setSubjectName("");
    setTaskCatagory("");
  }, []);

  // Safe access to browser environment
  const getBrowserUrl = () => {
    if (typeof window !== "undefined") {
      return window?.ENV?.BROWSER_URL || "https://example.com";
    }
    return "https://example.com";
  };

  return (
    <Center minH="100vh" bgGradient="linear(to-b, #7464ce, #fff)" px={2}>
      <Box
        bg="white"
        borderRadius="2xl"
        boxShadow="lg"
        p={[4, 8]}
        maxW="420px"
        w="100%"
        textAlign="center"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Box
          bg="#7464ce"
          borderRadius="full"
          w="64px"
          h="64px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          mb={6}
          mt={-12}
          boxShadow="0 4px 24px 0 rgba(162,89,255,0.12)"
        >
          <Icon as={MdSchool} color="white" boxSize={10} />
        </Box>
        <Text fontWeight="700" fontSize="2xl" color="#7464ce" mb={2}>
          Please go to your school specific URL
        </Text>
        <Text fontSize="md" color="#6b7280" mb={6}>
          Access your personalized learning experience through your school's dedicated portal
        </Text>
        <Box
          border="1px dashed #e5e7eb"
          borderRadius="lg"
          bg="#f9fafb"
          p={4}
          mb={6}
          w="100%"
        >
          <Text fontSize="xs" color="#a1a1aa" mb={1} letterSpacing="1px" fontWeight="600">
            SAMPLE URL FORMAT:
          </Text>
          <Box
            bg="white"
            borderRadius="md"
            px={3}
            py={2}
            fontSize="sm"
            color="#7464ce"
            fontFamily="monospace"
            border="1px solid #e5e7eb"
            wordBreak="break-all"
            display="inline-block"
          >
            {getBrowserUrl()}/school/aitutor/student/WSTBRY
          </Box>
        </Box>
        <Text fontSize="sm" color="#a1a1aa" mt={2}>
          Having trouble accessing your school portal? Contact your administrator for assistance.
        </Text>
      </Box>
    </Center>
  );
}